import {LIB_URL} from '../App';
import {loadLibrary} from '../modules/Util.js';

export function pharmaciesMap(newData) {
    let $mapWrap = $('.js-map-pharmacies');

    if ($mapWrap.length) {
        $mapWrap.data('rendered', true);

        loadLibrary(LIB_URL.YAMAP, () => {
            render(newData);
        },
        function() {
            console.log('fail ajax');
        });
    }
}

function render(newData) {
    let $mapWrap = $('.js-map-pharmacies');
    let $map = $mapWrap.find('.js-map');
    let objectManager = null;
    let allMapObjects;
    let MyBalloonLayout;

    if (newData) {
        $map.html('');
    }

    // отрисовка карты
    if ($mapWrap.length) {
        let map;

        ymaps.ready(function() {
            map = new ymaps.Map($map[0], {
                center: [55.761153, 37.650907],
                controls: [],
                zoom: 10
            });

            generateMapsData(map);
        });
    }

    function generateMapsData(_map) {
        let clusterIconLayout = ymaps.templateLayoutFactory.createClass('<div class="map-cluster">{{ properties.geoObjects.length }}</div>');
        let eventStartType = 'click';

        objectManager = new ymaps.ObjectManager({
            clusterize: true,
            gridSize: 60
        });

        // метка
        MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
            '<div class="bubble-content js-bubble-wrap">' +
            '$[[options.contentLayout observeSize minWidth=235 maxWidth=235 maxHeight=350]]' +
            '</div>',
            {
                build: function() {
                    this.constructor.superclass.build.call(this);
                    this._$element = $('.bubble-content', this.getParentElement());
                    this.applyElementOffset();
                },

                applyElementOffset: function() {
                    this._$element.css({
                        top: '20px',
                        left: '50%',
                        'margin-left': '-130px'
                    });
                },

                onSublayoutSizeChange: function() {
                    MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                    if (!this._isElement(this._$element)) {
                        return;
                    }

                    this.applyElementOffset();
                    this.events.fire('shapechange');
                },

                getShape: function() {
                    if (!this._isElement(this._$element)) {
                        return MyBalloonLayout.superclass.getShape.call(this);
                    }

                    var position = this._$element.position();

                    return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                        [position.left, position.top],
                        [
                            position.left + this._$element[0].offsetWidth,
                            position.top + this._$element[0].offsetHeight + this._$element.find('.arrow')[0].offsetHeight
                        ]
                    ]));
                },

                _isElement: function(element) {
                    return element && element[0] && element.find('.arrow')[0];
                }
            }
        );

        // генерируем метки на карте
        ymaps.option.presetStorage.add('cicle#blueMy', {
            iconLayout: ymaps.templateLayoutFactory.createClass([
                `<div class="pharm-point" data-id="{{id}}">\n  <div class="pharm-point__icon"></div>\n  </div>`
            ].join('')),
            iconShape: {
                type: 'Circle',
                coordinates: [0, -16],
                radius: 20,
            },
            hideIconOnBalloonOpen: false,
            zIndexHover: 999,
            balloonLayout: MyBalloonLayout,
            balloonContentLayout: ymaps.templateLayoutFactory.createClass([
                `<div class="bubble-content__price">{{properties.price}} ₽</div>
                    <div class="bubble-content__title js-map-item-address">{{properties.name}}</div>
                    <div class="bubble-content__time">{{properties.info | raw}}</div>
                    <div class="bubble-content__time"><div class="bubble-content__time-title">Дата самовывоза</div><div class="bubble-content__time-line">{{ properties.pickupDate }}</div></div>
                    <div class="button button--default bubble-content__button js-pharmacy-select" data-selected-btn="Выбрано" data-value="{{properties.value}}">Выбрать аптеку</div>
                `].join(''),
                {
                // Переопределяем функцию build, чтобы при создании макета начинать
                // слушать событие click на кнопке-счетчике.
                build: function() {
                    // Сначала вызываем метод build родительского класса.
                    this.constructor.superclass.build.call(this);
                    // А затем выполняем дополнительные действия.
                    $('.js-pharmacy-select').bind('click', this.onBtnClick);
                },

                // Аналогично переопределяем функцию clear, чтобы снять
                // прослушивание клика при удалении макета с карты.
                clear: function() {
                    // Выполняем действия в обратном порядке - сначала снимаем слушателя,
                    // а потом вызываем метод clear родительского класса.
                    $('.js-pharmacy-select').unbind('click', this.onBtnClick);
                    this.constructor.superclass.clear.call(this);
                },

                onBtnClick: function() {
                    let pharmacyId = $(this).data('value');
                    $(this).text($(this).data('selected-btn')).addClass('_selected');
                    $('#js-pharmacy-address').val(pharmacyId);

                    if ($('#js-pharmacy-address-text').length > 0) {
                        // для профиля
                        let pharmacyAddress = $(this).siblings('.js-map-item-address').text();
                        $('#js-pharmacy-address-text').val(pharmacyAddress);
                    } else {
                        // для второго шага корзины
                        $(this).closest('.js-order-form').find('.js-order-next').removeClass('_disabled').removeAttr('disabled');
                        $(this).closest('.js-order-form').find('.order-side .js-order-next').trigger('click');
                    }
                }
            })
        });

        objectManager.objects.options.set('preset', ymaps.option.presetStorage.get('cicle#blueMy'));

        // навели на метку
        objectManager.objects.events.add('mouseenter', function(e) {
            let objectId = e.get('objectId');
            $('.pharm-point[data-id="' + objectId + '"]').addClass('_hover');
        });

        // убрали наведение с метки
        objectManager.objects.events.add('mouseleave', function(e) {
            let objectId = e.get('objectId');

            $('.pharm-point[data-id="' + objectId + '"]').removeClass('_hover');
        });

        // клик на метку
        objectManager.objects.events.add(eventStartType, function (e) {
            let objectId = e.get('objectId');

            let currPoint = allMapObjects.filter(_obj => _obj.id === objectId);
            let currCoords = [currPoint[0].geometry.coordinates[0], currPoint[0].geometry.coordinates[1]];

            $('.pharm-point:not([data-id="' + objectId + '"])').removeClass('_active');
            $('.pharm-point[data-id="' + objectId + '"]').toggleClass('_active');

            // для второго шага корзины
            if ($('#js-pharmacy-address-text').length === 0) {
                $('.js-order-step').find('.mobile-menu-sum .js-order-next').removeClass('_disabled').addClass('_pharm-select');
            }

            _map.setCenter(currCoords);

            const position = _map.getGlobalPixelCenter();

            _map.setGlobalPixelCenter([
                position[0],
                position[1] + 100
            ]);
        });

        // кластеризация
        objectManager.clusters.options.set({
            clusterIconLayout: clusterIconLayout,
            clusterIconShape: {
                type: 'Circle',
                coordinates: [20, 20],
                radius: 20
            }
        });

        _map.geoObjects.add(objectManager);

        if (newData) {
            allMapObjects = newData.features;
            objectManager.add(newData);
            updateMapBounds();
        } else {
            loadAjaxMapData($map.data('pharmacies-data'), updateMapBounds);
        }

        function updateMapBounds() {
            if(allMapObjects.length) {
                _map.setBounds(_map.geoObjects.getBounds(), {
                    checkZoomRange: true,
                    zoomMargin: 35
                });
            }
        }
    }

    // загружаем данные
    function loadAjaxMapData(_path, callback) {
        $.ajax({
            url: _path,
            dataType: 'json'
        }).done(function(data) {
            allMapObjects = data.features;
            objectManager.add(data);
            if (callback) callback();
        });
    }
}

App.D.ready(() => {
    $('.js-map-pharmacies').closest('.js-simple-tab-content').each((i, tabContentDom) => {
        $(`.js-simple-tab[data-tab-id="${tabContentDom.id}"]`).one('click', () => pharmaciesMap());
    });
});
